import React from 'react';
import PastOrderListComponent from '../Presentation/PastOrderListComponent';
import Arrow from '../../../styles/staticAssets/images/CTA_Arrow.svg';
import ImageComponent from '../../../atoms/Image/index';
import {
  MY_ACCOUNT,
  ORDER_IT_AGAIN,
  SEE_FULL_ORDER_HISTORY,
  WELCOME_BACK,
  WELCOME_TO,
  KFC_LOVER,
  KFC_TEXT,
} from '../Constants/PastOrderConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { useHistory } from 'react-router-dom';

const PastOrderComponent = props => {
  const { pastOrders, basic, favouriteOrders, tenantReducerData, isLoggedIn } = props;
  const { componentOptions = {} } = tenantReducerData;
  const { homePage: homepageContant = {} } = componentOptions;
  const { pastorderFullOrderHistoryShowBtn = false } = homepageContant;
  const history = useHistory();

  const seeFullHistory = () => {
    localStorage.removeItem('LoadMoreOrderHistory');
    history.push({ pathname: '/account' });
    window.scrollTo(0, 0);
  };

  const seeFullHistoryPastOrder = () => {
    localStorage.setItem('LoadMoreOrderHistory', 'GoToOrderHistory');
    history.push({ pathname: '/account' });
    window.scrollTo(0, 0);
  };
  return (
    <div className={`pastorder-container pastorder-container-in`}>
      {isLoggedIn ? (
        <div className='pastorder-left-container'>
          <div data-testid='pastorder-strips-test' className='pastorder-stripes' />
          <div data-testid='pastorder-greeting-test' className='pastorder-greeting-heading'>
            <span>{translateWithI18Next(WELCOME_BACK)}, </span>
            <span>{basic?.firstName || translateWithI18Next(KFC_LOVER)}!</span>
          </div>
          <div className='pastorder-my-account'>
            <div className='pastorder-my-account-text' data-testid='see-full-history' onClick={seeFullHistory}>
              {translateWithI18Next(MY_ACCOUNT)}
              <ImageComponent srcFile={Arrow} className='pastorder-my-account-arrow' />
            </div>
          </div>
        </div>
      ) : (
        <div className='pastorder-left-container'>
          <div data-testid='pastorder-strips-test' className='pastorder-stripes' />
          <div data-testid='pastorder-greeting-test' className='pastorder-greeting-heading'>
            {`${translateWithI18Next(WELCOME_TO)} ${translateWithI18Next(KFC_TEXT)}!`}
          </div>
        </div>
      )}

      {(pastOrders?.length > 0 || favouriteOrders?.length > 0) && (
        <div className='pastorder-right-container pastorder-right-container-in'>
          <div className='pastorder-right-header'>
            <div className='pastorder-right-header-text'>{translateWithI18Next(ORDER_IT_AGAIN)}</div>
            <div className='pastorder-right-header-line' />
          </div>
          <PastOrderListComponent
            pastOrdersData={pastOrders}
            favouriteOrders={favouriteOrders}
            tenantReducerData={tenantReducerData}
          />
          {pastorderFullOrderHistoryShowBtn && (
            <p className='pastorder-full-history' data-testid='see-order-history' onClick={seeFullHistoryPastOrder}>
              {translateWithI18Next(SEE_FULL_ORDER_HISTORY)}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default PastOrderComponent;
